import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { WELCOME, REGISTRATION, SUMMARY } = USA.CONTENT

const partnerName = 'Iowa Total Care'

const iowaTotalCare: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    id: 'iowa-total-care',
    productConfigAppName: 'iowa-total-care',
    name: partnerName,
    codes: {
      membership: 'ITC',
    },
    partnerUrlSlug: 'iowa-total-care',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: (WELCOME.enUS.copy as CopyFunction)(partnerName),
        },
        REGISTRATION.enUS,
        SUMMARY.enUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const iowaTotalCareWithDnaV2Design: PartnerConfig = {
  ...iowaTotalCare,
  config: {
    ...iowaTotalCare.config,
    useDnaV2Design: true,
  },
}

export default [iowaTotalCare, iowaTotalCareWithDnaV2Design]
